<!--Section: Features v.2-->
<section class="text-center">

    <!--Section heading-->
    <h2 class="h1-responsive color-primary my-5">eo ipso</h2>
    <!--Section description-->
   
    <p class="px-5 mb-5 pb-3 lead text-dark mx-auto col-lg-8 text-justify"><b>Aus sich selbst heraus … eo ipso</b>
        möchte im Interesse des Kindes positive Veränderungen gemeinsam mit den Familienmitgliedern aus sich selbst heraus erarbeiten.
        In nunmehr zwei Jahrzehnten durften wir ressourcenorientierte, lösungsfokussierte und durch kreative Denk- und Handlungsansätze geprägte Erfahrungen in der sozialen Arbeit sammeln. Wir versuchen mit unseren Adressaten konstruktiv Lösungen zu erarbeiten, welche Stabilisierung, Stärkung und bestenfalls positive Änderungen hervorrufen. Unsere Arbeit zeichnet sich unter anderem durch die Fähigkeit aus, die passende Mischung aus therapeutischer Intervention und pragmatischer Alltagsanleitung zu finden, um die Ressourcen von Familien zu nutzen und die eigenverantwortliche Übernahme von Erziehungsaufgaben zu erreichen.
        </p>
 
</section>
